/* eslint-disable */
// ---文章サンプル---
const sampleNovel = function () {
  const contents = '黄色い晩\r\n\
小川未明\r\n\
　垣根の楓が芽を萌ふく頃だ。彼方あちらの往来で――杉林の下の薄暗い中で子供等らが隠れ事をしている。きゃっきゃっという声が重い頭に響く。北から西にかけて空は一面に黄色く――真黒な雲がその上に掩おおい被かぶさって、黄色な空をだんだんに押しつけて、下に沈ませているようだ。刻々に黄色な空が減じて終しまいには一直線となって、はっきりと地平線から此方こちらを覗き込んでいる。それが厭らしい細長い眼付で笑っているように思われた。\r\n\
　悪寒わるさむい風が北方の海から吹いて来る。煤けた障子を閉めて灰色の壁に向かった周蔵は、頭を手拭で鉢巻きして、床の上に起上って考え込んでいた。障子も一時は黄色に見えたが漸次薄暗くなって、子供等の鬼事おにごとの声も遠ざかってしまうと、遥かにボーッ、ボーッと蒸汽船の笛の音が聞える。三里彼方かなたの直江津の港を今しも出帆する汽船が新潟に向って立ったのであろう。\r\n\
\r\n\
　この時、私は周蔵を訪れた。\r\n\
　周蔵は三十二三の若者である。唇の尖った色の浅黒い丈夫そうな男である。彼は村の吉沢という家の次男で、この頃一人この家に別家したので、彼は独身者である。僅わずかばかりの金を別わけてもらって、その日その日を何もせずに暮しているのであった。昼でも彼はねころんでいる。いつ行って見ても彼はごろりとねろんで何かむしゃむしゃと食べていた。\r\n\
「周さん鳥が来たから指しておくれよ。」と沢山鶸ひわが裏の松林に来た時に行って頼んで見たが、\r\n\
「厭だ。」といって受け合あわなかった。\r\n\
　彼の家うちというのは三軒長屋の中である。去年あたりまで天理教の行者が住んでいたのであった。\r\n\
　その行者というのは、頭の禿げた目尻の垂れた口軽くちがるな、滑稽じみた男であったがたえず信者を集めて、加持祈祷をしていたので、今周蔵のいる家がその神様を祭った場所である。行者は西隣に住んでいた。今一軒の家には小学校の教師が住んでいたが、今でも尚なお住んでいる。\r\n\
　その頃周蔵のいる家の前は、往来に出るまで圃の中に細道があって、その道の両側に樫の木や、榛の木や、桜の木や、椿の木が植えられてあり、木の根には龍の髭が植られてあった。私はよくこの木の下に来て龍の髭に生なる青い実を他の多くの子供等と共に争っては取ったものだ。真夏の時分には樫の木の葉がちらちらと日光に輝いて赤い実が葉隠れに見え、蜻蛉が来ては頭の上をぐるぐると舞っているのを独り欲しそうにその木の下に佇んで、赤い実を見上げていたこともある。\r\n\
　今周蔵のいる家は、全く変っていて前には、格子戸が閉たっていた。中は薄暗く、鏡が光って、大きな太鼓と榊さかきに白紙の結び付けられた生花と、御幣と、白い徳利とくりとが目に入って、それに賽銭箱が直すぐ格子戸の際きわに置かれてあった。また賽銭箱の上にはだらりと赤、白、紫の交りの紐が垂下たれさがっていて、青錆の出た鈴が上に吊されていた。其等それらの紐は、多くの人々の手垢に汚れて下の方が黒くなっていたことを覚えている。その他堂の中には献納の絵額が五枚も六枚もかかっていた――毎月、三五の日には近隣の信者がこの狭い堂の中に集って、加持祈祷をしたので、その日には禿頭の行者は、時に応じ火渡りだの、刃渡などをして見せたこともあったという――僅かにそれが一年の後には、その行者は旅へ行ってしまって、その跡は全く変ってしまった。今迄あった桜の木や、樫の木は他へ移されてしまい、真直に往来に通っていた参詣人のための、道は耕されて圃となり、堂は造り代えられて、勝手許や便所まで附け加えられて、全くの普通の長屋となってしまい、その跡に入って来たのが、周蔵であった。'
  return contents
}
const sampleBracket = function () {
  const contents = 'あああ（い（いい（ううう）え（え）え）お）おお（かかか）ききき\r\n\
あああ＜い＜いい＜ううう＞え＜え＞え＞お＞おお＜かかか＞ききき\r\n\
あああ「い「いい「ううう」え「え」え」お」おお「かかか」ききき\r\n\
あああ【い【いい【ううう】え【え】え】お】おお【かかか】ききき\r\n\
あああ[い[いい[ううう]え[え]え]お]おお[かかか]ききき\r\n\
あああ{い{いい{ううう}え{え}え}お}おお{かかか}ききき'
  return contents
}
const samplePatent = function () {
  const contents = '\
【書類名】　特許請求の範囲\r\n\
【請求項１】\r\n\
　広角レンズと、\r\n\
　前記広角レンズを通して対象をＣＭＯＳセンサを用いてデータ化する読み取り部と、\r\n\
を備えるハンドスキャナ。\r\n\
【請求項２】\r\n\
　前記読み取り部は、さらに、前記データから前記平滑化処理により平滑化画像を生成する、\r\n\
請求項１に記載のハンドスキャナ。\r\n\
【請求項３】\r\n\
　前記読取り部は、さらに、前記平滑化画像の複数の特徴をエッジ処理により抽出する、\r\n\
請求項１又は請求項２に記載のハンドスキャナ。\r\n\
【請求項４】\r\n\
　前記広角レンズの材料は、ガラスである、\r\n\
請求項１から請求項３のいずれかに記載のハンドスキャナ。\r\n\
【請求項５】\r\n\
　前記データは、データベースに記憶される、\r\n\
請求項１から請求項４のいずれかに記載のハンドスキャナ。\r\n\
【請求項６】\r\n\
　広角レンズから対象からの光を取り入れ、\r\n\
　対象をＣＭＯＳセンサを用いてデータ化する、\r\n\
ハンドスキャニング方法。\r\n\
【請求項７】\r\n\
　前記データから平滑化処理により平滑化画像を生成する\r\n\
請求項６に記載のハンドスキャニング方法。\r\n\
【請求項８】\r\n\
　前記平滑化画像の複数の特徴をエッジ処理により抽出する、\r\n\
請求項６又は請求項７に記載のハンドスキャニング方法。\r\n\
【書類名】　明細書\r\n\
【発明の名称】　プリンター\r\n\
【技術分野】\r\n\
　【０００１】\r\n\
　本発明は、プリント範囲の確認が容易なプリンターに関するものである。\r\n\
【背景技術】\r\n\
　【０００２】\r\n\
　イメージ入力装置の中で、\r\n\
　【０００３】\r\n\
　しかし、文書の部分イメージ入力などに供するときには、\r\n\
　【０００４】\r\n\
　一般文書の任意の一部を入力する用途において、\r\n\
　【０００５】\r\n\
　この改善策として、\r\n\
【先行技術文献】\r\n\
【特許文献】\r\n\
　【０００６】\r\n\
【特許文献１】　特開２００３－００００００号公報\r\n\
　【０００７】\r\n\
【非特許文献１】　特許一郎著　「ハンドスキャナ」特許出版　２００３年\r\n\
【発明の概要】\r\n\
【発明が解決しようとする課題】\r\n\
　【０００８】\r\n\
　解決しようとする問題点は、ーー点である。\r\n\
【課題を解決するための手段】\r\n\
　【０００９】\r\n\
　本発明は、ーー主要な特徴とする。\r\n\
【発明の効果】\r\n\
　【００１０】\r\n\
　本発明のハンドスキャナは、ーー利点がある。\r\n\
【図面の簡単な説明】\r\n\
　【００１１】\r\n\
　【図１】　ハンドスキャナの実施方法を示した説明図である。\r\n\
　【図２】　ハンドスキャナの実施方法を示した説明図である。\r\n\
【発明を実施するための形態】\r\n\
　【００１２】\r\n\
　ハウジング外または可能な限りハウジング側端部に近い位置からイメージを入力するという目的を、ーー実現した。\r\n\
【実施例１】\r\n\
　【００１３】\r\n\
　図１は、本発明装置の１実施例の断面図であって、ーーである。\r\n\
　【００１４】\r\n\
　センサ３は入力位置Ｐ点を常に走査しており、ーー出力する。\r\n\
　【００１５】\r\n\
　一般にセンサ受光面の光軸方向の受光光量ＩC12は、ーー実用的な値の例を示す。\r\n\
　【００１６】\r\n\
　　【数１】\r\n\
　【００１７】\r\n\
　【００１８】\r\n\
　【００１９】\r\n\
　上記の数式において、表に示したように、Ｉはランプの放射光量、Ｘは観測面と受光面との距離、Ｖ／ｔは受光面の移動速度である。\r\n\
　【００２０】\r\n\
　このような光学系の実装形態を採用したので、ーーを低減する効果がある。\r\n\
　【００２１】\r\n\
　図２の実施例は、ハウジングに取付けたスイッチによって、ーーの拡大におおいに役立つ。\r\n\
【産業上の利用可能性】\r\n\
　【００２２】\r\n\
　筺体に取付けたスイッチを用いて容易に左右の選択ができ、ーーにも適用できる。\r\n\
【符号の説明】\r\n\
　【００２３】\r\n\
　１　ハンドスキャナハウジング\r\n\
　２　入力書面\r\n\
　３　１次元イメージセンサ\r\n\
　４　ワイドレンズ\r\n\
　５　照明ランプ\r\n\
【書類名】　図面\r\n\
　【図１】\r\n\
'
  return contents
}
const OfficeAction = function () {
  const contents = '　起案日　　　　　　　　　　令和○○年　○月○○日\r\n\
  　特許庁審査官　　　　　　　○○○\r\n\
  　特許出願人代理人　　　　　○○○　様\r\n\
  　適用条文　　　　　　　　　第２９条第２項\r\n\
  \r\n\
  \r\n\
  　この出願は、次の理由によって拒絶をすべきものです。これについて意見が\r\n\
  ありましたら、この通知書の発送の日から６０日以内に意見書を提出してくだ\r\n\
  さい。\r\n\
  \r\n\
  　　　　　　　　　　　　　　　　理由\r\n\
  \r\n\
  （進歩性）この出願の下記の請求項に係る発明は、その出願前に日本国内又は外\r\n\
  国において、頒布された下記の刊行物に記載された発明又は電気通信回線を通じ\r\n\
  て公衆に利用可能となった発明に基いて、その出願前にその発明の属する技術の\r\n\
  分野における通常の知識を有する者が容易に発明をすることができたものである\r\n\
  から、特許法第２９条第２項の規定により特許を受けることができない。\r\n\
  \r\n\
  　　　　　 記　　　（引用文献等については引用文献等一覧参照）'
  return contents
}
export default { sampleNovel, sampleBracket, samplePatent, OfficeAction}
